import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { ActivityArea } from '../model/activity-area';

@Injectable({
    providedIn: 'root'
  })
  export class ActivityAreaService{

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllSecteurs() 
    {
        return this._restClientService.load<ActivityArea[]>('activity-area/activity-areas');
    }
  
    add(secteur) {
        return  this._restClientService.save<ActivityArea>('activity-area/add-activity-area', secteur);
    }
      
    update(secteur) {
        return  this._restClientService.put<ActivityArea>(`activity-area/update-activity-area`, secteur);
    }
  
    getActivityAreaById(secteurId)
    {
      return this._restClientService.load<ActivityArea>('activity-area/activity-area-by-id/'+secteurId);
    }
  

}      

    